'use strict';

var List = require("bs-platform/lib/js/list.js");
var React = require("react");
var Pervasives = require("bs-platform/lib/js/pervasives.js");
var Caml_format = require("bs-platform/lib/js/caml_format.js");
var App$FormBuilder = require("./App.bs.js");
var FormContext$FormBuilder = require("./Context/FormContext.bs.js");

function formReducer(state, action) {
  switch (action.TAG | 0) {
    case /* AddInput */0 :
        return {
                action: /* Add */2,
                form: Pervasives.$at(state.form, {
                      hd: action._0,
                      tl: /* [] */0
                    })
              };
    case /* AddText */1 :
        var question = action._1;
        var id = action._0;
        return {
                action: /* Update */1,
                form: List.map((function (item) {
                        if (item.TAG === /* Text */0) {
                          var inputItem = item._0;
                          if (inputItem.id === id) {
                            return {
                                    TAG: /* Text */0,
                                    _0: {
                                      id: inputItem.id,
                                      question: question,
                                      answer: inputItem.answer
                                    }
                                  };
                          } else {
                            return {
                                    TAG: /* Text */0,
                                    _0: inputItem
                                  };
                          }
                        }
                        var scaleStart = item._2;
                        var rangeValue = item._1;
                        var inputItem$1 = item._0;
                        if (inputItem$1.id === id) {
                          return {
                                  TAG: /* Range */1,
                                  _0: {
                                    id: inputItem$1.id,
                                    question: question,
                                    answer: inputItem$1.answer
                                  },
                                  _1: rangeValue,
                                  _2: scaleStart
                                };
                        } else {
                          return {
                                  TAG: /* Range */1,
                                  _0: inputItem$1,
                                  _1: rangeValue,
                                  _2: scaleStart
                                };
                        }
                      }), state.form)
              };
    case /* ChangeRange */2 :
        var value = action._1;
        var id$1 = action._0;
        return {
                action: /* Update */1,
                form: List.map((function (item) {
                        if (item.TAG === /* Text */0) {
                          return item;
                        }
                        var scaleStart = item._2;
                        var inputItem = item._0;
                        if (inputItem.id === id$1) {
                          return {
                                  TAG: /* Range */1,
                                  _0: {
                                    id: inputItem.id,
                                    question: inputItem.question,
                                    answer: ""
                                  },
                                  _1: Caml_format.caml_int_of_string(value),
                                  _2: scaleStart
                                };
                        } else {
                          return {
                                  TAG: /* Range */1,
                                  _0: inputItem,
                                  _1: item._1,
                                  _2: scaleStart
                                };
                        }
                      }), state.form)
              };
    case /* ChangeScaleStart */3 :
        var scaleStartPosition = action._1;
        var id$2 = action._0;
        return {
                action: /* Update */1,
                form: List.map((function (item) {
                        if (item.TAG === /* Text */0) {
                          return item;
                        }
                        var rangeValue = item._1;
                        var inputItem = item._0;
                        if (inputItem.id === id$2) {
                          return {
                                  TAG: /* Range */1,
                                  _0: inputItem,
                                  _1: rangeValue,
                                  _2: scaleStartPosition
                                };
                        } else {
                          return {
                                  TAG: /* Range */1,
                                  _0: inputItem,
                                  _1: rangeValue,
                                  _2: item._2
                                };
                        }
                      }), state.form)
              };
    case /* DeleteInput */4 :
        var id$3 = action._0;
        return {
                action: /* Delete */3,
                form: List.filter(function (item) {
                        return item._0.id !== id$3;
                      })(state.form)
              };
    case /* Answer */5 :
        var answer = action._1;
        var id$4 = action._0;
        return {
                action: /* Update */1,
                form: List.map((function (item) {
                        if (item.TAG === /* Text */0) {
                          var inputItem = item._0;
                          if (inputItem.id === id$4) {
                            return {
                                    TAG: /* Text */0,
                                    _0: {
                                      id: inputItem.id,
                                      question: inputItem.question,
                                      answer: answer
                                    }
                                  };
                          } else {
                            return {
                                    TAG: /* Text */0,
                                    _0: inputItem
                                  };
                          }
                        }
                        var scaleStart = item._2;
                        var rangeValue = item._1;
                        var inputItem$1 = item._0;
                        if (inputItem$1.id === id$4) {
                          return {
                                  TAG: /* Range */1,
                                  _0: {
                                    id: inputItem$1.id,
                                    question: inputItem$1.question,
                                    answer: answer
                                  },
                                  _1: rangeValue,
                                  _2: scaleStart
                                };
                        } else {
                          return {
                                  TAG: /* Range */1,
                                  _0: inputItem$1,
                                  _1: rangeValue,
                                  _2: scaleStart
                                };
                        }
                      }), state.form)
              };
    
  }
}

function Root(Props) {
  var match = React.useReducer(formReducer, FormContext$FormBuilder.initialState);
  return React.createElement(FormContext$FormBuilder.Provider.make, FormContext$FormBuilder.Provider.makeProps([
                  match[0],
                  match[1]
                ], React.createElement(App$FormBuilder.make, {}), undefined));
}

var make = Root;

exports.formReducer = formReducer;
exports.make = make;
/* react Not a pure module */
